var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ServerSidePropsContext } from 'root/src/client/v2/common/helpers/gsspHelpers';
import { LanguageService, } from 'root/src/client/v2/common/helpers/language.service';
import { redirect } from 'root/src/client/util/redirects';
import { TranslatedLanguagesCodes } from 'root/src/shared/language/translatedLanguages.fixtures';
import domainName from 'root/src/aws/util/domainName';
const enDomain = `${TranslatedLanguagesCodes.En}.${domainName}`;
export const languageSwitcherMiddleware = (context) => __awaiter(void 0, void 0, void 0, function* () {
    const gssp = new ServerSidePropsContext(context);
    const host = gssp.getHost();
    if (!host) {
        return null;
    }
    if (host === enDomain) {
        return redirect(context.res, `https://${domainName}${gssp.ctx.resolvedUrl}`, true);
    }
    const languageCodeFromHost = LanguageService.getCodeFromHost(host);
    const languageCodeFromCookies = LanguageService.getValidCode(gssp.getCookie('languageCode'), null);
    if (!languageCodeFromCookies) {
        return null;
    }
    console.info('languageCodeFromHost', languageCodeFromHost, 'languageCodeFromCookies', languageCodeFromCookies);
    if (languageCodeFromHost !== languageCodeFromCookies) {
        const destination = LanguageService.getRedirectUrl(gssp.ctx.resolvedUrl, languageCodeFromCookies);
        return redirect(context.res, destination, true);
    }
    return null;
});
